export class BlockedItems {
    public type: BlockedItemsType;
    public items: Array<number>;
}

export enum BlockedItemsType {
    Users
}
